module.exports = __webpack_public_path__ + "static/CRS_10_new-83e7dd2ebab81959934b243875b8ccd1.svg";